<template>
  <modal class="order-cancel-modal" :modal="d_modal" >
    <template #titleContent>
      {{ $t('order.cancel.title') }}
    </template>

    <template #bodyContent>
      <d-row>
        <d-col class="mb-4" cols="12">
          {{ $t('order.cancel.confirmation_text') }}
        </d-col>

        <d-col cols="12">
          <d-row class="justify-content-between">
            <d-col cols="auto">
              <d-button @click="d_modal.close()" theme="primary">
                {{ $t('button.close') }}
              </d-button>
            </d-col>

            <d-col cols="auto">
              <r-button @click="cancelOrder" :error="d_mutation.error" :loading="d_mutation.loading" :success="d_mutation.success" theme="danger">
                {{ $t('order.action.confirm_cancel') }}
              </r-button>
            </d-col>
          </d-row>
        </d-col>

        <d-col v-if="d_mutation.errors.has('message')" cols="auto">
          {{ d_mutation.errors.get('message') }}
        </d-col>
      </d-row>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import Mutation from '@/library/Mutation';

export default {
  name: 'order-cancel-modal',
  components: { Modal },
  data () {
    return {
      d_orderId: '',
      d_mutation: new Mutation(),
    };
  },
  created () {
    this.d_orderId = this.d_modal.options.props.orderId;
  },
  methods: {
    cancelOrder () {
      this.d_mutation.reset();

      this.d_mutation.mutate(
        require('@/graphql/bookings/CancelOrder.gql'),
        {
          id: this.d_orderId,
        }
      ).then(({ data }) => {
 
       if(data.cancelOrder.success){
        window.location.reload(true)
       }

      });
    }
  }
}
</script>
